<template>
    <a
            class="plan"
            href="#!"
            @click="purchaseSubscriptionPlan(subscriptionPlan)"
            :class="{'has-promotional-tag' : subscriptionPlan.show_data.promotional_tag, 'active': active, 'premium': subscriptionPlan.premium}"
    >
        <div class="details">
            <h3 class="duration">
                {{subscriptionPlan.show_data.total.duration}} {{$tc(`subscription.periods.${subscriptionPlan.show_data.total.duration_type}`, subscriptionPlan.show_data.total.duration)}}
            </h3>
            <h5 class="payment">
                {{$t('subscription.payment_type.single', {amount: paymentAmountFormatted, currency_symbol: showCurrency.symbol, currency_description: '' /*showCurrency.description*/})}}
            </h5>
        </div>
        <div class="highlight">
            <div class="block big">
                <p class="period_amount">
                    {{periodAmountBigFormatted}}
                </p>
            </div>
            <div class="block small">
                <p class="period_amount">
                    <template  v-if="periodAmountSmallFormatted !== null">
                        .{{periodAmountSmallFormatted}}
                    </template>
                    <span class="asterisk">*</span>
                </p>
                <p class="period_type">
                    /{{$tc(`subscription.periods.${subscriptionPlan.show_data.breakdown.period_type}`, 1)}}
                </p>
            </div>
        </div>
        <div
                v-if="subscriptionPlan.show_data.promotional_tag"
                class="promotional-tag"
        >
            <div class="label">
                {{subscriptionPlan.show_data.promotional_tag}}
            </div>
        </div>
    </a>
</template>
<script>
    import Spinner from "./Spinner";

    export default {
        components: {
            Spinner
        },
        props: {
            subscriptionPlan: {
                type: Object,
                required: true,
                validator(subscriptionPlan){
                    return subscriptionPlan.hasOwnProperty('onward_subscription_plan');
                }
            },
            showCurrency: {
                required: true,
                type: Object
            },
            active: {
                required: false,
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {}
        },
        methods: {
            purchaseSubscriptionPlan(subscriptionPlan) {
                this.$emit('subscriptionPlanSelected', subscriptionPlan)
            },
        },
        computed: {
            periodAmountBigFormatted(){
                return Math.floor(Number(this.periodAmountFormatted)).toFixed(0);
            },
            periodAmountSmallFormatted(){
                if (this.showCurrency.decimal_precision === 0){
                    return null;
                }else{
                    return ((Number(this.periodAmountFormatted) % 1) * 100).toFixed(0).padEnd(this.showCurrency.decimal_precision,'0');
                }
            },
            periodAmountFormatted() {
                return Number(this.subscriptionPlan.show_data.breakdown.period_amount * this.showCurrency.amount_to_usd).toFixed(this.showCurrency.decimal_precision);
            },
            paymentAmountFormatted() {
                if(this.subscriptionPlan){
                    return Number(this.subscriptionPlan.show_data.total.amount * this.showCurrency.amount_to_usd).toFixed(this.showCurrency.decimal_precision);
                }else{
                    return null;
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    @import '../styles/classes';

    .plan{
        @extend %plan-button;

        &.premium{
          background: gold;
          color:#444444;
          &.hover{
            background: goldenrod;
          }
        }
      
        .asterisk{
            font-family: Arial, sans-serif;
            font-size: .65em;
        }
    }

    .smaller{
        font-size: .8em;
    }
</style>